export default class RestaurentModel {
  constructor({
    dbID,
    about,
    address,
    addressOne,
    addressTwo,
    area,
    biryani,
    breakFast,
    chinese,
    city,
    closingTime2,
    closingTime3,
    desserts,
    gstNo,
    healthy,
    image,
    indian,
    isOnlineOrder,
    isPickupDrop,
    multipleOrders,
    name,
    offerType,
    openingTime,
    openingTime2,
    openingTime3,
    petPoojaRestaurantId,
    pincode,
    pizza,
    restDiscount,
    restRating,
    restaurantBarNo,
    restaurantKitchenNo,
    restaurantNo,
    restaurantOwnerNo,
    shakes,
    shawarma,
    snacks,
    state,
    status,
    storeLat,
    storeLong,
    storeType,
    country,
    timings,
    featured,
    mainStoreId,
    storeId,
    pureVeg,
    totalRatings,
    subStores,
    isSubStore,
    preOrder,
    amenities,
  }) {
    this.dbID = dbID;
    this.about = about;
    this.address = address;
    this.addressOne = addressOne;
    this.addressTwo = addressTwo;
    this.area = area;
    this.biryani = biryani;
    this.breakFast = breakFast;
    this.chinese = chinese;
    this.city = city;
    this.closingTime2 = closingTime2;
    this.closingTime3 = closingTime3;
    this.desserts = desserts;
    this.gstNo = gstNo;
    this.healthy = healthy;
    this.image = image;
    this.indian = indian;
    this.isOnlineOrder = isOnlineOrder;
    this.isPickupDrop = isPickupDrop;
    this.multipleOrders = multipleOrders;
    this.name = name;
    this.offerType = offerType;
    this.openingTime = openingTime;
    this.openingTime2 = openingTime2;
    this.openingTime3 = openingTime3;
    this.petPoojaRestaurantId = petPoojaRestaurantId;
    this.pincode = pincode;
    this.pizza = pizza;
    this.restDiscount = restDiscount;
    this.restRating = restRating;
    this.restaurantBarNo = restaurantBarNo;
    this.restaurantKitchenNo = restaurantKitchenNo;
    this.restaurantNo = restaurantNo;
    this.restaurantOwnerNo = restaurantOwnerNo;
    this.shakes = shakes;
    this.shawarma = shawarma;
    this.snacks = snacks;
    this.state = state;
    this.status = status;
    this.storeLat = storeLat;
    this.storeLong = storeLong;
    this.storeType = storeType;
    this.country = country;
    this.timings = timings;
    this.featured = featured;
    this.mainStoreId = mainStoreId;
    this.storeId = storeId;
    this.pureVeg = pureVeg;
    this.totalRatings = totalRatings;
    this.subStores = subStores;
    this.isSubStore = isSubStore;
    this.preOrder = preOrder;
    this.amenities = amenities;
  }

  static fromJson(id, json) {
    return new RestaurentModel({
      dbID: id,
      about: json.about,
      address: json.address,
      addressOne: json.addressOne,
      addressTwo: json.addressTwo,
      area: json.area,
      biryani: isOnlineOrderValues.map[json.biryani],
      breakFast: isOnlineOrderValues.map[json.breakFast],
      chinese: isOnlineOrderValues.map[json.chinese],
      city: json.city,
      closingTime2: json.closingTime2 ?? "",
      closingTime3: json.closingTime3 ?? "",
      country: json.country ?? "India",
      desserts: isOnlineOrderValues.map[json.desserts],
      gstNo: json.gstNo,
      healthy: isOnlineOrderValues.map[json.healthy],
      image: json.image,
      indian: isOnlineOrderValues.map[json.indian],
      isOnlineOrder: isOnlineOrderValues.map[json.isOnlineOrder],
      isPickupDrop: isOnlineOrderValues.map[json.isPickupDrop],
      multipleOrders: isOnlineOrderValues.map[json.multipleOrders],
      name: json.name,
      offerType: json.offerType,
      openingTime: json.openingTime ?? "",
      openingTime2: json.openingTime2 ?? "",
      openingTime3: json.openingTime3 ?? "",
      petPoojaRestaurantId: json.petPoojaRestaurantId ?? "",
      pincode: json.pincode,
      pizza: isOnlineOrderValues.map[json.pizza],
      restDiscount: json.restDiscount,
      restRating: json.restRating.toString(),
      restaurantBarNo: json.restaurantBarNo,
      restaurantKitchenNo: json.restaurantKitchenNo,
      restaurantNo: json.restaurantNo,
      restaurantOwnerNo: json.restaurantOwnerNo,
      shakes: isOnlineOrderValues.map[json.shakes],
      shawarma: isOnlineOrderValues.map[json.shawarma],
      snacks: isOnlineOrderValues.map[json.snacks],
      state: json.state,
      status: statusValues.map[json.status],
      storeLat: json.storeLat,
      storeLong: json.storeLong,
      storeType: storeTypeValues.map[json.storeType],
      timings: json.timings ?? "",
      featured: isOnlineOrderValues.map[json.featured],
      mainStoreId: json.mainStoreId,
      storeId: json.storeId,
      pureVeg: json.pureVeg,
      totalRatings: json.totalRatings,
      subStores: json.subStores,
      isSubStore: json.isSubStore,
      preOrder: json.preOrder,
      amenities: json.amenities,
    });
  }

  toJson() {
    return {
      "dbID": this.dbID,
      "about": this.about,
      "address": this.address,
      "addressOne": this.addressOne,
      "addressTwo": this.addressTwo,
      "area": this.area,
      "biryani": isOnlineOrderValues.reverse[this.biryani] || "",
      "breakFast": isOnlineOrderValues.reverse[this.breakFast] || "",
      "chinese": isOnlineOrderValues.reverse[this.chinese] || "",
      "city": this.city,
      "closingTime2": this.closingTime2,
      "closingTime3": this.closingTime3,
      "country": this.country,
      "desserts": isOnlineOrderValues.reverse[this.desserts] || "",
      "gstNo": this.gstNo,
      "healthy": isOnlineOrderValues.reverse[this.healthy] || "",
      "image": this.image,
      "indian": isOnlineOrderValues.reverse[this.indian] || "",
      "isOnlineOrder": isOnlineOrderValues.reverse[this.isOnlineOrder] || "",
      "isPickupDrop": isOnlineOrderValues.reverse[this.isPickupDrop] || "",
      "multipleOrders": isOnlineOrderValues.reverse[this.multipleOrders] || "",
      "name": this.name,
      "offerType": this.offerType,
      "openingTime": this.openingTime,
      "openingTime2": this.openingTime2,
      "openingTime3": this.openingTime3,
      "petPoojaRestaurantId": this.petPoojaRestaurantId || "",
      "pincode": this.pincode,
      "pizza": isOnlineOrderValues.reverse[this.pizza] || "",
      "restDiscount": this.restDiscount,
      "restRating": this.restRating.toString(),
      "restaurantBarNo": this.restaurantBarNo,
      "restaurantKitchenNo": this.restaurantKitchenNo,
      "restaurantNo": this.restaurantNo,
      "restaurantOwnerNo": this.restaurantOwnerNo,
      "shakes": isOnlineOrderValues.reverse[this.shakes] || "",
      "shawarma": isOnlineOrderValues.reverse[this.shawarma] || "",
      "snacks": isOnlineOrderValues.reverse[this.snacks] || "",
      "state": this.state,
      "status": statusValues.reverse[this.status] || "",
      "storeLat": this.storeLat,
      "storeLong": this.storeLong,
      "storeType": storeTypeValues.reverse[this.storeType] || "",
      "timings": this.timings,
      "featured": isOnlineOrderValues.reverse[this.featured] || "",
      "mainStoreId": this.mainStoreId || "",
      "storeId": this.storeId || "",
      "pureVeg": this.pureVeg || "",
      "totalRatings": this.totalRatings || "0",
      "subStores": this.subStores || "No",
      "isSubStore": this.isSubStore || "No",
      "preOrder": this.preOrder,
      "amenities": this.amenities
    };
  }
}




class EnumValues {
  constructor(map) {
    this.map = map;
    this.reverseMap = {};
  }

  get reverse() {
    this.reverseMap = Object.fromEntries(
      Object.entries(this.map).map(([key, value]) => [value, key])
    );
    return this.reverseMap;
  }
}

export const IsOnlineOrder = {
  YES: "Yes",
  NO: "No",
};

export const isOnlineOrderValues = new EnumValues({
  "": IsOnlineOrder.NO,
  "No": IsOnlineOrder.NO,
  "Yes": IsOnlineOrder.YES,
});

export const Status = {
  ACTIVE: "Active",
  DE_ACTIVE: "DeActive",
};

export const statusValues = new EnumValues({
  "Active": Status.ACTIVE,
  "DeActive": Status.DE_ACTIVE,
});

export const StoreType = {
  HOTEL: "Hotel",
  RESTAURANT: "Restaurant",
  PG: "PG",
  ORGANIZATION: "Organization",
};

export const storeTypeValues = new EnumValues({
  "Hotel": StoreType.HOTEL,
  "Organization": StoreType.ORGANIZATION,
  "PG": StoreType.PG,
  "Restaurant": StoreType.RESTAURANT,
});